export default __webpack_public_path__ + "static/media/hc-logo-black.5998acf7.png";